import script from "./PaymentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPage.vue?vue&type=style&index=0&id=2507f7c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2507f7c0"]])

export default __exports__